import { AreaId,PrefectureId } from '@gyym/sdk'
import {
  CheckboxGroupModal,
  type CheckboxGroupModalProps,
  useModal,
} from '@gyym/ui'
import React from 'react'

import { useSearchAreaOptions } from './useSearchAreaOptions'

export interface Values {
  prefectureIds: PrefectureId[]
  areaIds: AreaId[]
}

type SearchAreaModalProps = Omit<
  CheckboxGroupModalProps<number, number>,
  'options'
>

const SearchAreaModal = (props: SearchAreaModalProps) => {
  const { data: areaOptions, isValidating } = useSearchAreaOptions(
    { withCount: true },
    { revalidateOnMount: true },
  )
  return (
    <CheckboxGroupModal
      {...props}
      baseWidth={430}
      isLoading={isValidating}
      options={areaOptions}
    />
  )
}

export const useSearchAreaModal = () => {
  const { openModal } = useModal()

  return React.useCallback(
    ({
      title = 'エリアから探す',
      onClose,
      onSubmit,
    }: {
      title?: string
      onClose?: () => void
      onSubmit: (values: Values) => void
    }) => {
      openModal(SearchAreaModal, {
        title,
        expandOnSmallDevices: true,
        onClose,
        onSubmit: ({ parentValues: prefectureIds, childValues: areaIds }) => {
          const values = { prefectureIds, areaIds } as Values
          onSubmit(values)
        },
      })
    },
    [openModal],
  )
}
